import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { ErrorBoundary } from '@betterment/shared-components';
import { Route, Routes, useMatch } from 'react-router-dom';

import { InformationConfirmationStep } from './steps/InformationConfirmationStep';
import { IntroductionStep } from './steps/IntroductionStep';
import { PlanSelectionStep } from './steps/PlanSelectionStep';

import { urlBuilder } from '../Shared/urlBuilder';

export function Controller() {
  const match = useMatch(`${urlBuilder.appAdvisorNetwork()}/*`);
  const returnToPath = urlBuilder.appHome.absolute();

  return (
    <ErrorBoundary fallbackType="full" feature="advisor_network" owner="user_engagement">
      <FlowContextProvider basePath={match!.pathnameBase} routePath="" returnToPath={returnToPath}>
        <Routes>
          <Route
            path="/plan_selection"
            element={
              <StepWrapper name="plan_selection">{stepProps => <PlanSelectionStep {...stepProps} />}</StepWrapper>
            }
          />
          <Route
            path="/introduction"
            element={<StepWrapper name="introduction">{stepProps => <IntroductionStep {...stepProps} />}</StepWrapper>}
          />
          <Route
            path="/information_confirmation"
            element={
              <StepWrapper name="information_confirmation">
                {stepProps => <InformationConfirmationStep {...stepProps} />}
              </StepWrapper>
            }
          />
        </Routes>
      </FlowContextProvider>
    </ErrorBoundary>
  );
}
